var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.74978 17.4159C3.18988 17.4159 2.65291 17.1934 2.257 16.7975C1.86109 16.4016 1.63867 15.8647 1.63867 15.3048V5.64994C1.63957 5.3224 1.71666 4.99957 1.86386 4.70698L3.27126 1.89216C3.31521 1.8048 3.38257 1.73136 3.46582 1.68005C3.54908 1.62873 3.64495 1.60156 3.74275 1.60156C3.84054 1.60156 3.93641 1.62873 4.01967 1.68005C4.10292 1.73136 4.17028 1.8048 4.21423 1.89216L5.62164 4.70698C5.76883 4.99957 5.84592 5.3224 5.84682 5.64994V15.3048C5.84683 15.8622 5.62635 16.3971 5.23347 16.7926C4.8406 17.1881 4.30724 17.4121 3.74978 17.4159V17.4159Z",
    stroke: "#7A49B9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.63867 5.62891H5.86089",
    stroke: "#7A49B9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.63867 14.0742H5.86089",
    stroke: "#7A49B9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3051 1.58203H10.0829C9.49993 1.58203 9.02734 2.05462 9.02734 2.63759V16.3598C9.02734 16.9428 9.49993 17.4154 10.0829 17.4154H14.3051C14.8881 17.4154 15.3607 16.9428 15.3607 16.3598V2.63759C15.3607 2.05462 14.8881 1.58203 14.3051 1.58203Z",
    stroke: "#7A49B9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.02734 4.75H11.4903",
    stroke: "#7A49B9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.02734 7.91406H11.4903",
    stroke: "#7A49B9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.02734 11.082H11.4903",
    stroke: "#7A49B9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.02734 14.25H11.4903",
    stroke: "#7A49B9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.ab84580b.svg";
export { ForwardRef as ReactComponent };